import { render } from "./OrderDetails.vue?vue&type=template&id=e8bfa10e&scoped=true"
import script from "./OrderDetails.vue?vue&type=script&lang=ts"
export * from "./OrderDetails.vue?vue&type=script&lang=ts"

import "./OrderDetails.vue?vue&type=style&index=0&id=e8bfa10e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e8bfa10e"

export default script